module.exports = __webpack_public_path__ + "img/background_space_wide.35d90de8.webp";